var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
export var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  padding: 32px;\n  min-height: 100vh;\n  height: 100%;\n  gap: 32px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  padding: 32px;\n  min-height: 100vh;\n  height: 100%;\n  gap: 32px;\n"])));
var templateObject_1;
